export function qrCode(data, size = 6) {

    const encoder = new TextEncoder();

    const qrData = encoder.encode(data);

    const bytes = [];

    // [1] Select model

    bytes.push(0x1d, 0x28, 0x6b, 0x04, 0x00, 0x31, 0x41, 0x32, 0x00);

    // [2] Set module size (1–16)

    bytes.push(0x1d, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x43, size);

    // [3] Set error correction (48=L,49=M,50=Q,51=H)

    bytes.push(0x1d, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x45, 49);

    // [4] Store data

    const pL = (qrData.length + 3) & 0xff;

    const pH = (qrData.length + 3) >> 8;

    bytes.push(0x1d, 0x28, 0x6b, pL, pH, 0x31, 0x50, 0x30, ...qrData);

    // [5] Print QR

    bytes.push(0x1d, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x51, 0x30);

    return new Uint8Array(bytes).buffer;

}